import { MessagePage } from "components/shared/pageLayouts/MessagePage";
import { usePageTitle, PAGE_TITLES, META_DESCRIPTIONS } from "util/pageTitle";

export const LimitReachedPage = () => {
  usePageTitle(PAGE_TITLES.LIMIT_REACHED, META_DESCRIPTIONS.LIMIT_REACHED);

  return (
    <MessagePage color="grey">
      <h2>This Lumo is Currently Unavailable 😕</h2>
      <h5>We're sorry, but this Lumo cannot be accessed right now.</h5>

      <div className="ls-info">
        <p>What can you do?</p>
        <ul>
          <li>Please try again later.</li>
          <li>Contact the creator for more information.</li>
        </ul>
      </div>
    </MessagePage>
  );
};
